import { render } from "./App.vue?vue&type=template&id=dbe18e28"
const script = {}

import "./App.vue?vue&type=style&index=0&id=dbe18e28&lang=css"

import exportComponent from "/Users/eugene/My/Projects/ek22f/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__